import {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import "../../style/scss/App.scss";

export default function EmployerRoleListItem(props) {
   return (
      <Link
         to={{
            pathname: "/employerRoleEdit/" + props.role.ID,
            state: { breadcrumb: props.breadcrumb },
         }}
      >
         <div className="Role mobilePanel">
            <span className="title">{props.role.Title}</span>
            <span className="byline">
               {props.employmentTypes.find((et) => et.Key === props.role.EmploymentTypeID).Value}
            </span>
            <span className="rightText">{props.postings.filter((p) => p.EmployerRoleID === props.role.id).length}</span>
         </div>
      </Link>
   );
}


